import styled, { css } from "styled-components";
import {
  minMedium,
  useContentMargins,
} from "@songtradr-one/components-frontend";

// TEXT

// STYLES
export const Page = styled.div(() => {
  const [margin] = useContentMargins();

  return css`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 3rem 0 11.5rem 0;
    margin: 0 ${margin};

    @media ${minMedium} {
      gap: 3rem;
    }
  `;
});

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
